import { ReactComponent as CarpenterIcon } from "../assets/image/CarpenterSVG.svg";
import ElectricPhoto from "../assets/image/Electrician1.png";
import PlumberPhoto from "../assets/image/plumber_300x200.png";
import CleanerPhoto from "../assets/image/cleaner_300x200.png";
import leakDetectionService from "../assets/image/leak-detection-service.jpg";
import waterSoftnerService from "../assets/image/water-softener-service.jpg";
import drainCleaning from "../assets/image/drain-cleaning-service.jpg";
import heaterService from "../assets/image/water-heaters-service.jpg";
import grinderService from "../assets/image/grinder-systems-service.jpg";
import FurnitureAssemblyImg from "../assets/image/s1.webp";
import HomeRepairs from "../assets/image/s2.webp";
import HeavyFurnitureMoving from "../assets/image/s3.webp";
import HomeCleaningServices from "../assets/image/s4.webp";
import Plumbing from "../assets/image/ps1.jpeg";
import ElectricalHelp from "../assets/image/ElectricalHelp.webp";
import Door from "../assets/image/door.webp";
import Appliance from "../assets/image/phmwlkvwspljqlnykoqz.webp";
import FanInstallation from "../assets/image/fan.webp";
import AC from "../assets/image/ac.webp";
import Painting from "../assets/image/paint.webp";
import Light from "../assets/image/light.webp";
import Tiles from "../assets/image/Tile.webp";
import Bel from "../assets/image/bel.webp";
import HowWorkImg from "../assets/image/how_it_works_pic_updated.webp";
// import DevForHire from "../../src/assets/image/dev for hire.jpg";
// import CV from "../assets/docs/Sanket-Resume.pdf"

export const LoginKey = "login";
export const TokenKey = "token";
export const ProfileKey = "profile";

export const services = [
  {
    icon: PlumberPhoto,
    title: "Plumber",
    desc: "Leak repairs & pipe fixes",
    category: "plumber",
  },
  {
    icon: ElectricPhoto,
    title: "Electrician",
    desc: "Wiring & appliance safety",
    category: "electrician",
  },
  {
    icon: <CarpenterIcon />,
    title: "Carpenter",
    desc: "Furniture & woodwork",
    category: "carpenter",
  },
  {
    icon: CleanerPhoto,
    title: "House Maid",
    desc: "Cleaning & upkeep",
    category: "maid",
  },
];

export const ServiceByCategory = {
  plumber: [
    {
      id: "plumber_leak_detection",
      image: leakDetectionService,
      title: "Leak Detection Service",
      price: 99,
    },
    {
      id: "plumber_water_softner",
      image: waterSoftnerService,
      title: "Water Softner Service",
      price: 99,
    },
    {
      id: "plumber_drain_cleaning",
      image: drainCleaning,
      title: "Drain Cleaning Service",
      price: 99,
    },
    {
      id: "plumber_heater_service",
      image: heaterService,
      title: "Heater Service",
      price: 99,
    },
    {
      id: "plumber_grinder_service",
      image: grinderService,
      title: "Grinder System Service",
      price: 99.0,
    },

    {
      id: 7,
      title: "Plumbing",
      image: Plumbing,
      price: 100,
    },
  ],

  electrician: [
    {
      id: "electrician_fault_detection",
      image: leakDetectionService,
      title: "Electrical Fault Detection",
      price: 99,
    },
    {
      id: "electrician_switch_socket_repair",
      image: waterSoftnerService,
      title: "Switch & Socket Repair",
      price: 99,
    },
    {
      id: "electrician_wiring_service",
      image: drainCleaning,
      title: "Electrical Wiring Service",
      price: 99,
    },
    {
      id: "electrician_appliance_installation",
      image: heaterService,
      title: "Appliance Installation",
      price: 99,
    },
    {
      id: "electrician_panel_maintenance",
      image: grinderService,
      title: "Electrical Panel Maintenance",
      price: 99,
    },

    {
      id: 8,
      title: "Electrical Help",
      image: ElectricalHelp,
      price: 100,
    },
    {
      id: 9,
      title: "Light Installation",
      image: Light,
      price: 100,
    },
    {
      id: 10,
      title: "Fan Installation",
      image: FanInstallation,
      price: 100,
    },
    {
      id: 11,
      title: "Install Air Conditioner",
      image: AC,
      price: 100,
    },
    {
      id: 12,
      title: "Appliance Installation & Repairs",
      image: Appliance,
      price: 100,
    },
    {
      id: 13,
      title: "Doorbell Installation",
      image: Bel,
      price: 100,
    },
  ],

  carpenter: [
    {
      id: 1,
      title: "Furniture Assembly",
      image: FurnitureAssemblyImg,
      price: 100,
    },
    {
      id: "carpenter_furniture_repair",
      image: leakDetectionService,
      title: "Furniture Repair",
      price: 99,
    },
    {
      id: "carpenter_custom_woodwork",
      image: waterSoftnerService,
      title: "Custom Woodwork",
      price: 99,
    },
    {
      id: "carpenter_door_window_fix",
      image: drainCleaning,
      title: "Door & Window Repair",
      price: 99,
    },
    {
      id: "carpenter_installation_service",
      image: heaterService,
      title: "Furniture Installation",
      price: 99,
    },
    {
      id: "carpenter_polishing_finishing",
      image: grinderService,
      title: "Polishing & Finishing",
      price: 99,
    },

    {
      id: 2,
      title: "Door & Cabinet Repair",
      image: Door,
      price: 100,
    },
    {
      id: 3,
      title: "Home Repairs",
      image: HomeRepairs,
      price: 100,
    },
    {
      id: 4,
      title: "Heavy Furniture Moving",
      image: HeavyFurnitureMoving,
      price: 100,
    },
    {
      id: 14,
      title: "Painting",
      image: Painting,
      price: 100,
    },
    {
      id: 15,
      title: "Flooring & Tiling Help",
      image: Tiles,
      price: 100,
    },
  ],

  maid: [
    {
      id: "maid_home_cleaning",
      image: leakDetectionService,
      title: "Home Cleaning",
      price: 99,
    },
    {
      id: "maid_kitchen_cleaning",
      image: waterSoftnerService,
      title: "Kitchen Cleaning",
      price: 99,
    },
    {
      id: "maid_bathroom_cleaning",
      image: drainCleaning,
      title: "Bathroom Cleaning",
      price: 99,
    },
    {
      id: "maid_regular_maintenance",
      image: heaterService,
      title: "Regular Cleaning Service",
      price: 99,
    },
    {
      id: "maid_deep_cleaning",
      image: grinderService,
      title: "Deep Cleaning",
      price: 99,
    },

    {
      id: 5,
      title: "Home Cleaning",
      image: HomeCleaningServices,
      price: 100,
    },
  ],
};

export const holidayServices = [
  {
    id: 13,
    title: "Holiday",
    des: "A description of what user getting with the service",
    price: 100,
  },
  {
    id: 24,
    title: "Party",
    des: "A description of what user getting with the service",
    price: 100,
  },
  {
    id: 34,
    title: "Assembly",
    des: "A description of what user getting with the service",
    price: 100,
  },
  {
    id: 48,
    title: "Furniture",
    des: "A description of what user getting with the service",
    price: 100,
  },
  {
    id: 59,
    title: "Furniture Assembly",
    des: "A description of what user getting with the service",
    price: 100,
  },
];

export const HowWork = {
  img: HowWorkImg,
  category: "How it works",
  services: [],
  listData: [
    "Choose a Service by price, skills, and reviews.",
    "Schedule a Service as early as today",
    "Chat, pay, tip, and review all in one place.",
  ],
};

export const reviewsBySubService = {
  electrician_fault_detection: {
    avgRating: 4.5,
    totalReviews: 2,
    reviews: [
      {
        id: 1,
        userName: "Rahul S.",
        rating: 5,
        comment: "Fault detected and resolved quickly.",
        createdAt: "2026-01-09T10:20:00Z",
      },
    ],
  },

  electrician_switch_socket_repair: {
    avgRating: 4.2,
    totalReviews: 1,
    reviews: [
      {
        id: 2,
        userName: "Amit K.",
        rating: 4,
        comment: "Clean work, no issues so far.",
        createdAt: "2026-01-07T15:40:00Z",
      },
    ],
  },

  subservice_8: {
    avgRating: 4.8,
    totalReviews: 3,
    reviews: [
      {
        id: 3,
        userName: "User",
        rating: 4,
        comment: "Baavli gaand.",
        createdAt: "2026-01-05T09:10:00Z",
      },
      {
        id: 5,
        userName: "User 1 ",
        rating: 3,
        comment: "Baavli gaand.",
        createdAt: "2026-01-05T09:10:00Z",
      },
      {
        id: 4,
        userName: "User 3",
        rating: 2,
        comment: "Baavli gaand.",
        createdAt: "2026-01-05T09:10:00Z",
      },
    ],
  },
};

export const alternateSection = [
  // {
  //   title: "Developer For Hire",
  //   description: [
  //     "A results-driven full-stack developer available for contract or full-time engagements.",
  //     "Experienced in modern JavaScript frameworks, component-driven UI development.",
  //   ],
  //   ctas: [
  //     { label: "Hire Me", action: "hire" },
  //     {
  //       label: "Download CV",
  //       action: "download",
  //       url: CV,
  //     },
  //   ],
  //   image: DevForHire,
  //   reverse: false,
  // },
  {
    title: "Brand Strategy",
    description: [
      "We want you to be fully satisfied with our Ramukaka Repairing Services.",
      "Our professional team is ready to provide reliable Carpenter, Electrician, and Plumbing services for your home and office.",
      "Ramukaka Repairing Services is committed to delivering quality work with honesty and affordable pricing.",
      "You can book our services easily through our website for quick and hassle-free support.",
      "Our skilled technicians ensure safe, efficient, and long-lasting repair solutions.",
      "We truly appreciate our customers for trusting Ramukaka Repairing Services for their home maintenance needs.",
    ],
    image: "https://images.unsplash.com/photo-1606676539940-12768ce0e762",
    reverse: true,
  },
];
